import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-xs-6" }
const _hoisted_2 = ["data-node", "title"]
const _hoisted_3 = { class: "node-header" }
const _hoisted_4 = {
  class: "nodedetail",
  style: {"overflow-x":"auto"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_node_icon = _resolveComponent("node-icon")!
  const _component_node_status = _resolveComponent("node-status")!
  const _component_node_filter_link = _resolveComponent("node-filter-link")!
  const _component_node_details_simple = _resolveComponent("node-details-simple")!
  const _component_popover = _resolveComponent("popover")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_popover, {
      modelValue: _ctx.popoverVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.popoverVisible) = $event)),
      trigger: "click",
      "show-delay": 0,
      "hide-delay": 200,
      placement: "auto",
      "append-to": "body",
      viewport: "#section-content",
      "custom-class": `node-embed-popover ${_ctx.node.islocal ? 'server' : ''}`
    }, {
      popover: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["detailpopup node_entry tooltipcontent", { server: _ctx.node.islocal }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_node_icon, { node: _ctx.node }, null, 8, ["node"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.node.nodename), 1),
            _createVNode(_component_node_filter_link, {
              "node-filter": `name: ${_ctx.node.nodename} `,
              onNodefilterclick: _ctx.filterClick
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "glyphicon glyphicon-circle-arrow-right" }, null, -1)
              ]))]),
              _: 1
            }, 8, ["node-filter", "onNodefilterclick"]),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "nodedesc" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_node_details_simple, {
              attributes: _ctx.node.attributes,
              "show-exclude-filter-links": _ctx.showExcludeFilterLinks,
              authrun: _ctx.node.authrun,
              "use-namespace": true,
              tags: _ctx.node.tags,
              "node-columns": true,
              onFilter: _ctx.filterClick
            }, null, 8, ["attributes", "show-exclude-filter-links", "authrun", "tags", "onFilter"])
          ])
        ], 2)
      ]),
      default: _withCtx(() => [
        _createElementVNode("a", {
          "data-role": "trigger",
          class: "node_ident embedded_node tight",
          tabindex: "0",
          role: "button",
          style: _normalizeStyle(_ctx.styleForNode(_ctx.node.attributes)),
          "data-node": _ctx.node.nodename,
          title: _ctx.node.nodename
        }, [
          _createVNode(_component_node_icon, { node: _ctx.node }, null, 8, ["node"]),
          _createElementVNode("span", {
            style: {"margin":"0 0.5em"},
            class: _normalizeClass({ node_unselected: _ctx.node.unselected })
          }, _toDisplayString(_ctx.node.nodename), 3),
          _createVNode(_component_node_status, { node: _ctx.node }, null, 8, ["node"])
        ], 12, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue", "custom-class"])
  ]))
}